'use strict';

module.exports = {
    disableButtonSubmit: function () {
        var submitButtons = document.querySelectorAll('.btn-submit');

        /**
         * Disables each submit button when its own form has an invalid field group,
         * so one form's error never blocks another form's button.
         * @returns {void}
         */
        function checkInvalidGroups() {
            for (let i = 0; i < submitButtons.length; i++) {
                const scope = submitButtons[i].closest('form') || document;
                submitButtons[i].disabled = scope.querySelector('.form-group.is-invalid') !== null;
            }
        }

        checkInvalidGroups();

        var observer = new MutationObserver(function (mutationsList) {
            for (let i = 0; i < mutationsList.length; i++) {
                if (mutationsList[i].attributeName === 'class') {
                    checkInvalidGroups();
                    break;
                }
            }
        });

        document.querySelectorAll('.form-group').forEach(group => {
            observer.observe(group, { attributes: true });
        });
    }
};


